import React from 'react';

interface CartGlyphProps {
  size?: number;
}

// Outline cart with two filled dots in the basket, so it reads as holding
// something. Stroked in `currentColor` so the parent owns the color — the PNGs
// this replaces were a baked-in white, which is what made ENG-2550 possible.
const CartGlyph: React.FC<CartGlyphProps> = ({ size = 25 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.7}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M2.2 3.2h1.6a1.1 1.1 0 0 1 1.07.86L5.3 6.2m0 0 1.72 7.9a1.6 1.6 0 0 0 1.56 1.25h8.1a1.6 1.6 0 0 0 1.56-1.22L19.9 6.2H5.3Z" />
    <circle cx="9.2" cy="19.6" r="1.5" />
    <circle cx="17.4" cy="19.6" r="1.5" />
    <circle cx="9.6" cy="10.4" r="1.15" fill="currentColor" stroke="none" />
    <circle cx="13.2" cy="10.4" r="1.15" fill="currentColor" stroke="none" />
  </svg>
);

export default CartGlyph;
